import React, { Component } from 'react'
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {playButtonTap,playFreeMusic,playTimeMusic} from './PlaySounds';

class ModeIntroScreen extends Component {

  constructor(props){
      super(props);
      this.state = {
          error : null,
          isLoaded : false,
          configs : []          
      };
  }

  componentDidMount(){
    if(localStorage.getItem('game_mode') === "free"){
      playFreeMusic();
    }else{
      playTimeMusic();
    }
    fetch('/game-skins/build-rev23-PfhLPVSBF/data_'+this.props.language+'/game_custom_config.json')
    .then( response => response.json())
    .then(
        // handle the result
        (result) => {
            this.setState({
                isLoaded : true,
                configs : result
            });
        },

        // Handle error 
        (error) => {
            this.setState({
                isLoaded: true,
                error
            })
        },
    )
}

goToTrueFalseDefinition = () => {
        playButtonTap();
        this.props.history.push('/truefalse');
    };
    

    render() {
      localStorage.setItem('language',this.props.language);
      var content = "";
      var direction = "";
      var GameTimed = this.state.configs.map(config => (config.GameTimed))
      var GameSelfPaced = this.state.configs.map(config => (config.GameSelfPaced))
      if(this.props.language === "en"){
        if(localStorage.getItem('game_mode') === "free"){
          content = `Welcome to the Self-paced Mode.`+GameSelfPaced;
        }else{
          content = `Welcome to the Timed Challenge. You will have 60 seconds to sort through statements.`+GameTimed;
        }
         
           direction = "ltr";
      }else if(this.props.language === "ur"){
        if(localStorage.getItem('game_mode') === "free"){
          content = `آییۓ ہم کورونا کمبیٹ کا تفریح موڈ کھیلتے ہیں! اس موڈ میں آپ اپنی رفتار پر کورونا وائرس سے متعلق جملوں کو سچ یا جھوٹ منتخب کر سکتے ہیں. ہر درست انتخاب پر آپکو ١ سکور ملے گا اور اپکا فائنل سکور دو چیزوں پر مشتمل ہوگا`;
        }else{
          content = `آییۓ ہم کورونا کمبیٹ کا وقتی چیلنج کھیلتے ہیں! آپ کے پاس ١٥٠ سیکنڈز کا وقت ہوگا جس میں آپ نے کورونا وائرس سے متعلق جملوں کو سچ یا جھوٹ منتخب کرنا ہے. ہر درست انتخاب پر آپکو ١ سکور ملے گا اور اپکا فائنل سکور دو چیزوں پر مشتمل ہوگاآپ نے کتنے جملوں کا جواب دیا اوران میں سے کتنے  جواب درست ہیں`;
        }
          direction = "rtl";
      }
            return(
                <div className = "screen_background popup_top_padding">
                  <div className = "popup">
                    <div  className= "scroll_div">
                      <div dir={direction}>
                        {content}
                      </div>  
                      </div>
                  </div>
                  <img src={"/game-skins/build-rev23-PfhLPVSBF/images_"+this.props.language+"/btn_next.png"} alt="" className="button" onClick = {this.goToTrueFalseDefinition}/>
                </div>
            )
    }
}

ModeIntroScreen.propTypes = {
  language:PropTypes.string.isRequired,
  configs: PropTypes.array
}
const mapStateToProps = state =>({
  language: localStorage.getItem('language',"en"),
  configs: []
});
export default connect(mapStateToProps)(ModeIntroScreen);
//export default withRouter(IntroScreen);



// WEBPACK FOOTER //
// ./src/components/ModeIntroScreen.js